<app-progress-bar class="z-50"></app-progress-bar>
<router-outlet></router-outlet>